// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PIybO","title":"styles_title__qE5V9","avatar":"styles_avatar__OClY2"};